import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import {
  ReactiveFormsModule,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { generate } from 'rxjs';

@Component({
  selector: 'app-employee-edit',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './employee-edit.component.html',
  styleUrl: './employee-edit.component.scss',
})
export class EmployeeEditComponent {
  member: any;
  isDependent: boolean = false;
  isEdit: boolean = false;
  sponsorId: string = '';
  insuranceClasses: string[] = ['A', 'B', 'C', 'VIP', 'Basic'];
  onChange: boolean = false;
  memberForm: FormGroup;

  constructor(
    private dialogRef: MatDialogRef<EmployeeEditComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder
  ) {
    this.isDependent = data.isDependent || false;
    this.isEdit = data.isEdit || false;
    this.member = data.member;
    this.sponsorId = data.sponsorId || '';
    console.log('Member Data:', this.member);

    if (this.isEdit) {
      this.memberForm = this.fb.group({
        id: [this.member?.id],
        nameArabic: [
          this.member?.nameArabic || this.member?.nameAr || '',
          Validators.required,
        ],
        firstNameEnglish: [this.member?.firstNameEn || '', Validators.required],
        lastNameEnglish: [this.member?.lastNameEn || '', Validators.required],
        jobTitle: [
          this.member?.jobTitle || '',
          // Conditional validator for jobTitle
          this.isDependent ? [] : Validators.required,
        ],
        insuranceClass: [
          this.member?.insuranceClass || '',
          Validators.required,
        ],
        idNumber: [this.member?.idNumber || '', Validators.required],
        dateOfBirth: [this.member?.dateOfBirth || '', Validators.required],
        sponsorId: [{ value: this.sponsorId || '', disabled: true }],
        mobileNumber: [
          this.member?.mobileNumber || '',
          [Validators.required, Validators.pattern(/^\d{10}$/)],
        ],
        gender: [this.member?.gender || '', Validators.required],
        isMarried: [this.member?.married, Validators.required],
        relation: [
          this.member.relation,
          this.isDependent ? Validators.required : [],
        ],
      });
      this.memberForm.get('sponsorId')?.enable({ emitEvent: false });
      this.memberForm.valueChanges.subscribe(() => {
        this.onChange = true;
      });
    } else {
      this.memberForm = this.fb.group({
        id: [null],
        firstNameEnglish: ['', Validators.required],
        lastNameEnglish: ['', Validators.required],
        nameArabic: ['', Validators.required],
        jobTitle: ['', this.isDependent ? [] : Validators.required],
        insuranceClass: ['', Validators.required],
        idNumber: ['', Validators.required],
        dateOfBirth: ['', Validators.required],
        sponsorId: [{ value: this.sponsorId, disabled: true }],
        mobileNumber: [
          '',
          [Validators.required, Validators.pattern(/^\d{10}$/)],
        ],
        gender: ['', Validators.required],
        isMarried: ['', Validators.required],
        relation: [
          '',
          // Conditional validator for relation
          this.isDependent ? Validators.required : [],
        ],
      });

      this.memberForm.get('sponsorId')?.enable({ emitEvent: false });
      this.memberForm.valueChanges.subscribe(() => {
        this.onChange = true;
      });
    }
  }

  onClose() {
    this.dialogRef.close();
  }

  onSave() {
    console.log('Form Value:', this.memberForm.value);
    if (this.memberForm.invalid) {
      console.error('Form is invalid', this.memberForm.errors);
      this.memberForm.markAllAsTouched();
      return;
    }
    this.dialogRef.close({ ...this.memberForm.value, onChange: this.onChange });
  }
}
